export default "dist/images/components-columns-width-control-3-1-grid.ae0e2fa.png";